import { render, staticRenderFns } from "./sceneManage.vue?vue&type=template&id=9509bbc6"
import script from "./sceneManage.vue?vue&type=script&lang=js"
export * from "./sceneManage.vue?vue&type=script&lang=js"
import style0 from "./sceneManage.vue?vue&type=style&index=0&id=9509bbc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports